import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import Modal from 'app/components/Modal';

const MessageModal = props => {
  const {
    isOpen,
    message,
    onClose,
    title,
    subTitle,
    headerVariant,
    headerIcon
  } = props;

  let btnSize = 'large';

  // by default, a single OK button is rendered.
  // if primary button is set then confirmation and cancel buttons are rendered.
  // (confirmButtonLabel & onConfirm are aliases for primaryButtonLabel & onPrimaryButtonClick)
  // if secondary button is set then default confirmation is rendered with the custom secondary button.
  // also both primary and secondary buttons can be customized
  let primaryButtonLabel = props.primaryButtonLabel || props.confirmButtonLabel;
  let onPrimaryButtonClick = props.onPrimaryButtonClick || props.onConfirm;
  let secondaryButtonLabel = props.secondaryButtonLabel || 'Cancel';
  let { onSecondaryButtonClick } = props;

  if (!primaryButtonLabel) {
    if (onPrimaryButtonClick) {
      primaryButtonLabel = 'Confirm';
    } else {
      primaryButtonLabel = 'OK';
    }
  }

  let buttons = [];

  // setup confirm / ok button.
  // this will always appear and just closes the modal by default
  buttons.push({
    color: 'primary',
    size: btnSize,
    label: primaryButtonLabel,
    onClick: () => {
      if (!onPrimaryButtonClick) {
        onClose();
        return;
      }

      // if onPrimaryButtonClick returns a promise, then wait before closing.
      // otherwise call and close
      let result = onPrimaryButtonClick();
      if (result?.then) {
        result.then(onClose);
      } else {
        onClose();
      }
    }
  });

  // if a primary / confirm button was set then assume we want a cancel button.
  // or setup the secondary button if set, instead of the cancel button.
  // (the user can still cancel with the X icon in the upper right)
  if (onPrimaryButtonClick || onSecondaryButtonClick) {
    buttons.push({
      color: 'secondary',
      size: btnSize,
      label: secondaryButtonLabel,
      onClick: () => {
        if (!onSecondaryButtonClick) {
          onClose();
          return;
        }

        // if onSecondaryButtonClick returns a promise, then wait before closing.
        // otherwise call and close
        let result = onSecondaryButtonClick();
        if (result?.then) {
          result.then(onClose);
        } else {
          onClose();
        }
      }
    });
  }

  const messageStyle = {
    margin: '2rem 0'
  }

  const buttonStyle = {
    width: '49%'
  }

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={title}
      subTitle={subTitle}
      headerVariant={headerVariant}
      headerIcon={headerIcon}
    >
      <Typography sx={messageStyle}>{message}</Typography>
      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection="row-reverse"
      >
        {buttons.map(button => ((
          <Button
	    key={'btn-' + button.label}
            onClick={button.onClick}
            variant="contained"
            color={button.color}
            size={button.size}
            disabled={button.disabled}
            sx={buttonStyle}
          >
            {button.label}
          </Button>
        )))}
      </Box>
    </Modal>
  );
}

export default MessageModal;
